import {
  Menu,
  MenuButton,
  Button,
  MenuList,
  MenuItem,
  Icon,
  Flex,
  Box,
  Text,
  Input,
  InputGroup,
  InputLeftElement,
  Image,
  Tooltip,
} from '@chakra-ui/react'
import { ChevronDownIcon, SearchIcon } from '@chakra-ui/icons'
import { Controller, useFormContext } from 'react-hook-form'
import { useState, useMemo } from 'react'

export const Select = ({ name, icon, label, options, customTopComponent, ...props }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext()
  const [previewMessage, setPreviewMessage] = useState(null)
  const [searchTerm, setSearchTerm] = useState('')

  const handleMouseEnter = (message) => {
    if (name === 'mensagem_whatsapp' || name === 'mensagem_email') {
      setPreviewMessage(message)
    }
  }

  const handleMouseLeave = () => {
    setPreviewMessage(null)
  }

  const filteredOptions = useMemo(() => {
    if (!searchTerm) return options
    return options.filter(
      (option) =>
        option.label.toLowerCase().includes(searchTerm.toLowerCase()) ||
        (option.preview && option.preview.toLowerCase().includes(searchTerm.toLowerCase()))
    )
  }, [options, searchTerm])

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Menu>
          <MenuButton
            bgColor="#FFFFFF"
            fontWeight="bold"
            fontSize="15px"
            borderColor={errors[name] ? 'red.500' : '#378BBF'}
            borderWidth="1px"
            as={Button}
            rightIcon={<ChevronDownIcon />}
          >
            <Flex alignItems="center" justifyContent="center" gap={2}>
              <Icon as={icon} fontSize="24px" color={errors[name] ? 'red.500' : '#3182ce'} />
              <Text noOfLines={1} overflow="hidden" textOverflow="ellipsis" wordBreak="break-word">
                {label}
              </Text>
            </Flex>
          </MenuButton>
          {errors[name] && (
            <Text color="red.500" fontSize="12px" mt={1}>
              {errors[name].message}
            </Text>
          )}
          <MenuList
            maxW="720px"
            minW="720px"
            position="relative"
            h="300px"
            sx={{
              overflowY: 'scroll',
              '&::-webkit-scrollbar': {
                width: '8px',
              },
              '&::-webkit-scrollbar-track': {
                background: '#f1f1f1',
                borderRadius: '4px',
              },
              '&::-webkit-scrollbar-thumb': {
                background: '#888',
                borderRadius: '4px',
              },
              '&::-webkit-scrollbar-thumb:hover': {
                background: '#555',
              },
            }}
          >
            {customTopComponent && (
              <Box p={3} borderBottom="1px solid" borderColor="gray.200">
                {customTopComponent}
              </Box>
            )}

            {props.hasToolTip && (
              <Box p={3} borderBottom="1px solid" borderColor="gray.200">
                <InputGroup size="sm">
                  <InputLeftElement pointerEvents="none">
                    <SearchIcon color="gray.400" />
                  </InputLeftElement>
                  <Input
                    placeholder="Pesquisar mensagem..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    borderColor="gray.200"
                    _focus={{ borderColor: 'blue.500' }}
                  />
                </InputGroup>
              </Box>
            )}

            {filteredOptions.map((option, index) => (
              <Tooltip
                key={option.value}
                isOpen={previewMessage?.value === option.value && option.preview}
                label={option.preview && <Image src={option.preview} alt="Preview da mensagem" maxH="400px" maxW="500px" objectFit="contain" />}
                placement="auto"
                hasArrow
                bg="transparent"
                gutter={20}
              >
                <MenuItem
                  onClick={() => field.onChange(option)}
                  onMouseEnter={() => handleMouseEnter(option)}
                  onMouseLeave={handleMouseLeave}
                  bg={index % 2 === 0 ? 'white' : '#EFEFEF'}
                  _hover={{ bg: index % 2 === 0 ? 'gray.50' : 'gray.100' }}
                  fontSize="13px"
                  color="#2D2D2D"
                  h="auto"
                  py={2}
                >
                  <Flex alignItems="center" gap={3}>
                    <Flex
                      alignItems="center"
                      justifyContent="center"
                      w="24px"
                      h="24px"
                      borderRadius="full"
                      bg="#3182ce"
                      color="white"
                      fontSize="12px"
                      fontWeight="bold"
                      flexShrink={0}
                    >
                      {String(index + 1).padStart(2, '0')}
                    </Flex>
                    <Text noOfLines={2} overflow="hidden" textOverflow="ellipsis" wordBreak="break-word">
                      {option.label}
                    </Text>
                  </Flex>
                </MenuItem>
              </Tooltip>
            ))}
          </MenuList>
        </Menu>
      )}
    />
  )
}
